import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../hooks/useAppDispatch";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";
import { RootState } from "../../../../redux/store";
import { generateGetURL } from "../../../../services/mediaApiService";

import placeHolderImage from "../../../../assets/placeholders/picture.jpg";

const LOCALE = "modules_Guests_components_AsideSection_EventDetails";

const EventDetails: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const {
    eventName,
    eventDate,
    profilePicture,
    thumbnailSmall,
  } = useAppSelector((state: RootState) => state.guestGiftTable);

  const [profileImageUrl, setProfileImageUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfileImage = async () => {
      const imageID = thumbnailSmall || profilePicture;
      if (imageID) {
        try {
          const media = await generateGetURL(imageID);
          setProfileImageUrl(media.signedURL);
        } catch (error) {
          console.error("Error fetching profile picture:", error);
          setProfileImageUrl(null);
        }
      }
    };
    fetchProfileImage();
  }, [profilePicture, thumbnailSmall]);

  return (
    <div className="bg-secondary p-4 rounded-md space-y-4 relative">
      <div className="relative">
        <img
          src={profileImageUrl || placeHolderImage}
          alt={t("eventImage")}
          className="w-32 h-32 rounded-full object-cover mx-auto mb-4"
        />
      </div>
      <div>
        <p className="text-sm">{t("eventNameLabel")}</p>
        <h4 className="text-lg font-bold">{eventName || t("notAvailable")}</h4>
      </div>
      <div>
        <p className="text-sm">{t("eventDateLabel")}</p>
        <h4 className="text-lg font-bold">{eventDate || t("notAvailable")}</h4>
      </div>
    </div>
  );
};

export default withTranslations(LOCALE)(EventDetails);
